import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'employeeAbsence';

const employeeAbsenceService = {
  getAbsenceById: (id) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/row/${encodeURIComponent(id)}`,
    });
  },

  getAbsences: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/absences`,
      data,
    });
  },

  createAbsence: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  updateAbsence: (data, id) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
      data,
    });
  },

  withdrawAbsence: (id) => {
    return request({
      method: Methods.PATCH,
      resource: `${baseURL}/${encodeURIComponent(id)}/withdraw`,
    });
  },

  deleteAbsence: (id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },
};

export default employeeAbsenceService;
